import { render, staticRenderFns } from "./TransportRouteResult.vue?vue&type=template&id=61f72bae&scoped=true&"
import script from "./TransportRouteResult.vue?vue&type=script&lang=js&"
export * from "./TransportRouteResult.vue?vue&type=script&lang=js&"
import style0 from "./TransportRouteResult.vue?vue&type=style&index=0&id=61f72bae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f72bae",
  null
  
)

export default component.exports